/**
 * Switch script file
 **/
export default {
  name: 'app-ToggleSwitch',
  mixins: [],
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    name: {
      type: String,
      default: 'switch',
      required: false
    },
    label: {
      type: String,
      default: '',
      required: false
    },
    labelPosition: {
      type: String,
      default: 'right',
      required: false
    }
  },
  data () {
    return {
      currentState: false
    }
  },
  mounted () {
    this.currentState = this.value
  },
  watch: {
    value (val) {
      this.currentState = val
    }
  },
  computed: {
  },
  methods: {
    toggle (event) {
      event.preventDefault()
      if (this.disabled) { return false }

      const checked = this.currentState !== true
      this.currentState = checked

      const obj = {
        name: this.name,
        state: checked
      }

      this.$emit('change', obj)
    }
  }
}
